$(function () {
  const slider = $(".topicDetail-otherCAE__list");
  if (slider.length != -1) {
    slider.slick({
      variableWidth: true,
      slidesToShow: 4,
      responsive: [
        {
          breakpoint: 991, //未満
          settings: {
            arrows: false,
            slidesToShow: 1,
          },
        },
      ],
    });
  }
});
